import React from 'react';
import Nav from './Nav';

const Header = props => {
  return (
    <header className="bg-white black-80 pv2">
      <div className="tc">
        <a href="/" className="dib pa3 w3 h2 br-100 relative">
          <svg
            className="h2 w3 absolute left-0 top-0 black-80"
            fill="#333333"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            x="0px"
            y="0px"
            viewBox="0 0 402.667 226.5"
            enableBackground="new 0 0 402.667 226.5"
          >
            <path d="M393.775,178.616c-0.074-0.146-0.191-0.383-0.311-0.607C393.619,178.306,393.716,178.501,393.775,178.616z" />
            <path d="M393.775,178.616C393.875,178.814,393.857,178.773,393.775,178.616L393.775,178.616z" />
            <path d="M382.558,156.482c1.412,0.007,2.824,0.011,4.264,0.011c4.553,0,7.451-5.068,5.209-8.994l-10.363-17.997  c1.107-0.004,2.213-0.012,3.332-0.012c4.361,0,7.35-4.746,5.389-8.668l-32.266-75.479c-1.008-2.014-3.119-3.332-5.373-3.332  c-41.311,0-80.219,7.69-109.562,21.659c-19.975,9.508-34.113,21.282-41.578,34.308c-7.464-13.026-21.603-24.799-41.576-34.308  c-29.339-13.968-68.246-21.66-109.553-21.66c-2.229,0-4.383,1.307-5.367,3.315l-32.492,75.479c-1.983,3.921,1.019,8.686,5.382,8.686  c1.725,0,3.435,0.006,5.135,0.018l-10.358,17.989c-2.178,3.939,0.605,8.994,5.209,8.994c1.438,0,2.85-0.004,4.261-0.01  l-10.623,20.962c-2.139,4.278,1.517,9.319,6.286,8.642l148.797-13.439c3.163,14.514,16.439,13.846,35.02,13.846  c18.582,0,31.856,0.668,35.021-13.846l148.807,13.439c6.471,1.019,8.25-7.408,7.625-8.642L382.558,156.482z M34.737,117.666  c-0.75-0.158-1.514-0.171-2.253-0.043c-1.599-0.029-3.205-0.055-4.821-0.074l26.502-63.495c38.169,0.438,73.814,7.646,100.71,20.451  c24.904,11.855,39.223,26.946,40.716,42.757l0.038,44.694C169.167,142.438,108.883,119.251,34.737,117.666z M372.119,117.596  c-0.6-0.083-1.213-0.071-1.82,0.03c-79.842,1.492-138.123,22.197-162.568,44.088l-0.104-44.453  c1.494-15.812,15.813-30.902,40.721-42.757c26.895-12.802,62.537-20.012,100.703-20.452l26.316,63.495  C374.279,117.562,373.199,117.579,372.119,117.596z" />
            <path d="M393.181,177.446c0.037,0.072,0.064,0.129,0.102,0.194C393.222,177.524,393.181,177.446,393.181,177.446z" />
          </svg>
        </a>
        <h1 className="mt1 mb2 mb0 baskerville i fw1 f2">Hacker Book Review</h1>
        <h2 className="mt1 mb2 mb0 f6 fw4 ttu tracked">What Hackers Read</h2>
      </div>
      <Nav {...props} />
    </header>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js